import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function HeroPopup({ product, onClose }) {
  const navigate = useNavigate();

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);

  const handleBackdropClick = (e) => {
    if (e.target.classList.contains('hero-popup-backdrop')) {
      onClose();
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Escape') {
      onClose();
    }
  };

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  // Navigate to Products page without reload or loader
  const handleViewProducts = () => {
    onClose(); // Close popup first
    navigate('/products'); // SPA navigation
  };

  // Generate unique class names based on product name
  const getProductClassName = () => {
    const nameMap = {
      'SURU': 'suru',
      'GaDaI (गडी)': 'gadai',
      'TRUUNA': 'truuna'
    };
    return nameMap[product.name] || 'default';
  };

  const productClass = getProductClassName();

  return (
    <div 
      className={`hero-popup-backdrop hero-popup-backdrop-${productClass}`} 
      onClick={handleBackdropClick}
    >
      <div className={`hero-popup-container hero-popup-container-${productClass}`}>
        <button className="hero-popup-close" onClick={onClose} aria-label="Close popup">
          ✕
        </button>
        <div className={`hero-popup-content hero-popup-content-${productClass}`}>
          <div className={`hero-popup-image hero-popup-image-${productClass}`}>
            <img src={product.image} alt={product.name} />
          </div>
          <div className={`hero-popup-info hero-popup-info-${productClass}`}>
            <h2>{product.name}</h2>
            <p>{product.description}</p>
            
            {/* View Products Navigation Button */}
            <button 
              className={`hero-popup-view-products hero-popup-view-products-${productClass}`}
              onClick={handleViewProducts}
            >
              🔍 View Products
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HeroPopup;